/* istanbul ignore file */

import { AuthProtectedComponent } from '@statsbomb/kitbag-auth';
import { ReactNode } from 'react';
import { useVideoPlayerTranslations } from '@/hooks/useVideoPlayerTranslations';
import { VideoKeyBoardShortcutProvider, VideoProvider as VideoLibraryProvider } from '@statsbomb/video-client-js';
import env from '@/env';

export const VideoProvider = ({ children }: { children: ReactNode }) => {
  const translationOverrides = useVideoPlayerTranslations();

  return (
    <VideoLibraryProvider
      baseUrlVideoService={env.VITE_VIDEO_SERVICE_URL}
      streamsOnly
      translations={translationOverrides}
    >
      {children}
    </VideoLibraryProvider>
  );
};

export const VideoAuthAndKeyboardWrapper = ({ children }: { children: ReactNode }) => (
  <AuthProtectedComponent>
    <VideoKeyBoardShortcutProvider>{children}</VideoKeyBoardShortcutProvider>
  </AuthProtectedComponent>
);
